import styled, { css } from 'styled-components';

import { system, SystemProps } from '@sternum/styled-system';

export const ContainerWithFixedLoadingStyled = styled.div<SystemProps>`
  position: relative;
  width: 100%;
  height: 100%;

  ${system}
`;

export const ContentContainer = styled.div<SystemProps & { isVisible: boolean }>`
  width: 100%;
  height: 100%;

  ${(props) => css`
    visibility: ${props.isVisible ? 'visible' : 'hidden'};
  `};

  ${system};
`;

export const SpinnerContainer = styled.div`
  display: inline-flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
